<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onSelectAll)="onSelectAll($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="card-toolbar" before-btns>
    <!-- groupDeletion btn -->
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>

    <!-- download -->
    <div [matTooltip]="'common.download' | translate">
      <button
        (click)="downloadBlackListGetApi()"
        [disabled]="(items$ | async)?.length == 0"
        class="btn btn-light txt-lg button-shadow tw-mx-1 tw-mr-1 btn-hover-rise"
        type="button"
        mat-ripple
        style="width: 51px"
      >
        <i
          *ngIf="!downloadLoading"
          class="mdi mdi-download mdi-20px tw-p-0 text-success"
        ></i>
        <span
          *ngIf="downloadLoading"
          class="spinner-border spinner-border-sm text-success tw-mt-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </div>

  <!--------------------------------- Table Content --------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <td>
          <div class="form-check tw-text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mt-[1px]"
              (click)="onAddSelectedId($event, item?.mobile, row)"
              [attr.data-checkbox-id]="item.mobile"
            />
          </div>
        </td>

        <!-- mobile -->
        <td>
          <td-value copyToClipboard [value]="item?.mobile"></td-value>
        </td>

        <!-- type -->
        <td>
          <span copyToClipboard>{{
            item?.type | enumToText : BlackListTypeEnumValues
          }}</span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <td class="sticky-td">
          <!-- delete -->
          <a
            (click)="onDelete(item.mobile)"
            class="btn btn-sm"
            [matTooltip]="'common.delete' | translate"
          >
            <i class="mdi mdi-trash-can-outline mdi-20px text-danger"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-black-list-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-black-list-form>
</ng-container>

<!-------------------------------- Audit -------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    [hideReferenceId]="true"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!-------------------------------- help -------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
